import React from 'react';

import logoImage from '../../../assets/images/new_logo.png';

import { LogoImageWrapper } from './style';

export default function Logo() {
  return (
    <LogoImageWrapper>
      <img
        src={logoImage}
        alt="company logo"
        style={{ width: 124 }}
      />
    </LogoImageWrapper>
  );
}
